export class ExtractAdapter {
  static toTermsInputDTO(req: any): any {
    return {
      query: req,
      // is_endorsed: true,
    };
  }

  static toTermsOutputDTO(res: any): any {
    return (
      res.map((attr: any, index: number) => ({
        id: index + 1,
        key: attr,
        value: true,
      })) || []
    );
  }

  static toExtractEdgesInputDTO(req: any): any {
    return {
      terms: req,
      is_saved: false,
    };
  }

  static toExtractEdgesOutputDTO(res: any): any {
    return (
      res?.map((attr: any) => ({
        id: attr.doc_edge.edge_id,
        source: {
          id: attr.doc_edge.source_term.term_id,
          key: attr.doc_edge.source_term.value,
        },
        target: {
          id: attr.doc_edge.target_term.term_id,
          key: attr.doc_edge.target_term.value,
        },
        section: attr.doc_edge.doc_texts[0].section.title,
        desc: attr.doc_edge.doc_texts[0].text,
      })) || []
    );
  }

  static toTermEdgesInputDTO(req: any): any {
    return req.filter((item: any) => item.value).map((item: any) => item.key);
  }

  static toExtractedEdgesInputDTO(): any {
    return { is_saved: true };
  }

  static toExtractedEdgesOutputDTO(res: any): any {
    return (
      res?.map((attr: any) => ({
        id: attr.doc_edge.edge_id,
        source: {
          id: attr.doc_edge.source_term.term_id,
          key: attr.doc_edge.source_term.value,
        },
        target: {
          id: attr.doc_edge.target_term.term_id,
          key: attr.doc_edge.target_term.value,
        },
        status: attr.is_ready ? "using" : "unused",
        section: attr.doc_edge.doc_texts[0].section.title,
        desc: attr.doc_edge.doc_texts[0].text,
        saved_at: attr?.client_saved_at,
      })) || []
    );
  }

  static toSaveExtractEdgesInputDTO(req: any): any {
    return req
      .filter((item: any) => !item.is_saved)
      .map((item: any) => item.id);
  }

  static toCausalRuleOutputDTO(res: any): any {
    return (
      res?.map((attr: any) => ({
        id: attr.doc_edge.edge_id,
        source: {
          id: attr.doc_edge.source_term.term_id,
          key: attr.doc_edge.source_term.value,
        },
        target: {
          id: attr.doc_edge.target_term.term_id,
          key: attr.doc_edge.target_term.value,
        },
        status:
          attr.doc_edge.source_term.value && attr.doc_edge.target_term.value
            ? "using"
            : "unused",
        section: attr.doc_edge.doc_texts[0].section.title,
        desc: attr.doc_edge.doc_texts[0].text,
        saved_at: attr?.client_saved_at,
      })) || []
    );
  }

  static toCausalRuleInputDTO(req: any): any {
    return req.map((attr: any) => attr.id) || [];
  }
}
